import GlobalService from './globalService';

export default function useService(axiosIns, overrideConfig) {
  const service = new GlobalService(axiosIns, overrideConfig);

  return {
    service
  };
}
